

















































































import { computed, defineComponent, PropType, ref, toRefs, watch } from '@vue/composition-api';
import Identity from './index';
import { AvatarData, CreateIdentityFormData } from './types';
import { CUSTOM_IDENTITY_OPERATOR } from './const';
import { i18n } from './../../i18n';

const name = 'ttam-identity-create-compose';

export default defineComponent({
  name,
  components: {
    TtamIdentityCustomCreateAvatar: Identity.TtamIdentityCustomCreateAvatar,
    TtamIdentityCustomCreateName: Identity.TtamIdentityCustomCreateName,
  },
  props: {
    value: {
      type: Object as PropType<CreateIdentityFormData>,
      default: () => ({}),
    },
    isPopover: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    submitLoading: {
      type: Boolean,
      default: false,
    },
    dialogType: {
      type: String,
      default: CUSTOM_IDENTITY_OPERATOR.ADD, // add or edit
    },
    clean: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { value: initData, isPopover, visible, dialogType } = toRefs(props);
    const curFormData = ref<CreateIdentityFormData>({
      displayName: initData.value?.displayName || '',
      avatarIcon: initData.value?.avatarIcon || {},
    });
    const handleBlur = () => {
      emit('blur');
    };
    const componentType = computed(() => (isPopover.value ? 'vi-dialog' : 'div'));
    const componentProps = computed(() =>
      isPopover.value
        ? {
            visible: visible.value,
            title:
              dialogType.value === CUSTOM_IDENTITY_OPERATOR.ADD
                ? i18n.t('module_creative_identity_add_new_custom_action_text')
                : i18n.t('module_creative_identity_edit_title'),
            closeOnClickModal: false,
            appendToBody: true,
          }
        : {},
    );

    // avatar
    const { headers, action } = Identity.useCustomCreateAvatarProps();
    const avatarValue = computed(() => curFormData.value.avatarIcon?.url);

    const onInput = (data: Partial<CreateIdentityFormData>) => {
      curFormData.value = {
        ...curFormData.value,
        ...data,
      };
      if (!isPopover.value) {
        // 非弹窗模式，直接 input 值
        emit('input', curFormData.value);
        emit('change', curFormData.value);
      }
    };

    const onAvatarSuccess = (data: AvatarData) => {
      const { image_info } = data;
      onInput({
        avatarIcon: {
          height: image_info.height,
          hash: image_info.hash,
          width: image_info.width,
          webUri: image_info.web_uri,
          uri: data.uri,
          url: data.url,
        },
      });
      emit('avatar-change', data);
    };

    // name
    const { displayNameValidator, displayNameInnerValidator } = Identity.useCustomCreateRules();

    const onDisplayNameChange = (val: string) => {
      onInput({
        displayName: val,
      });
      emit('display-name-change', val);
    };

    // form
    const identityCreateForm = ref(null);

    // dialog
    const onDialogClose = () => {
      emit('close');
    };

    const submitAdd = () => {
      emit('submit-add', curFormData.value);
    };

    const submitEdit = () => {
      emit('submit-edit', curFormData.value);
    };

    const onSubmit = () => (dialogType.value === CUSTOM_IDENTITY_OPERATOR.ADD ? submitAdd() : submitEdit());

    const onConfirm = () => {
      identityCreateForm.value.validate((isValidate: boolean) => {
        if (isValidate) {
          onSubmit();
        }
      });
    };

    watch(
      initData,
      val => {
        curFormData.value.displayName = val?.displayName || '';
        curFormData.value.avatarIcon = val?.avatarIcon || {};
      },
      {
        immediate: true,
        deep: true,
      },
    );

    return {
      name,
      headers,
      action,
      avatarValue,
      curFormData,
      componentType,
      componentProps,
      identityCreateForm,
      displayNameValidator,
      displayNameInnerValidator,
      onConfirm,
      onDialogClose,
      onAvatarSuccess,
      handleBlur,
      onDisplayNameChange,
      CUSTOM_IDENTITY_OPERATOR,
    };
  },
});
